import React, { useState } from "react";

import { AccordionItem } from "./AccordionItem";
import { Input } from "./Input";
import { LinkSpec } from "./linkSpec";
import { Mail } from "./icons/Mail";
import { T } from "./Footer.tlocale";
import { UniversalLinkWrapper } from "./universalLink";

interface FooterMenuSocialItem {
  icon: (props: React.SVGProps<SVGSVGElement>) => JSX.Element;
  to: string;
}

interface FooterMenuItem {
  label: string;
  link: LinkSpec;
}

interface FooterMenu {
  id: string;
  label: string;
  items: FooterMenuItem[];
}

interface FooterProps {
  menus: FooterMenu[];
  links: FooterMenuItem[];
  socialLinks: FooterMenuSocialItem[];
  copyright: string;

  emailTitle: string;
  emailIntro: string;
  email: string;
  onEmailChange: (v: string) => void;
  onEmailSubmit: () => void;

  emailForm?: string;
}

export const Footer = (props: FooterProps) => {
  const [active, setActive] = useState("");
  const renderMenuItems = (items: FooterMenuItem[]) => (
    <div className="txt-body-mobile-12 tablet:txt-body-14 text-body flex gap-3.5 flex-col pb-6 tablet:pb-0 tablet:mt-3.5">
      {items.map((v, idx) => (
        <UniversalLinkWrapper className="cursor-pointer select-none" key={idx} spec={v.link}>
          {v.label}
        </UniversalLinkWrapper>
      ))}
    </div>
  );
  return (
    <div className="bg-input px-4 pb-4 tablet:px-[110px] tablet:py-[48px]">
      <div className="flex gap-6 tablet:gap-12 flex-col tablet:flex-row justify-between">
        <div className="hidden tablet:flex gap-16">
          {props.menus.map((v) => (
            <div key={v.id}>
              <div className="txt-body-14sb text-ash">{v.label}</div>
              {renderMenuItems(v.items)}
            </div>
          ))}
        </div>
        <div className="flex flex-col tablet:hidden">
          {props.menus.map((v) => (
            <AccordionItem
              hack="footer"
              label={v.label}
              key={v.id}
              expanded={active === v.id}
              onClick={() => {
                setActive(active === v.id ? "" : v.id);
              }}
            >
              {renderMenuItems(v.items)}
            </AccordionItem>
          ))}
        </div>
        <div className="tablet:w-[364px]">
          {props.emailTitle ? <div className="txt-body-14 txt-body-14sb text-off-black">{props.emailTitle}</div> : null}
          {props.emailIntro ? (
            <div className="txt-body-mobile-12 txt-body-14 text-body mt-2">{props.emailIntro}</div>
          ) : null}
          {props.emailForm !== undefined ? (
            <div dangerouslySetInnerHTML={{ __html: props.emailForm }} />
          ) : (
            <form
              onSubmit={(e) => {
                e.preventDefault();
                props.onEmailSubmit();
              }}
            >
              <Input
                className="mt-4"
                kind="text"
                placeholder={T("Enter your email")}
                value={props.email}
                onChange={props.onEmailChange}
                icon={{ kind: "right", component: Mail }}
              />
            </form>
          )}
          <div className="flex flex-wrap gap-4 mt-6 text-label">
            {props.socialLinks.map((v, idx) => (
              <a key={idx} href={v.to} target="_blank" rel="noopener noreferrer">
                {v.icon({ className: "w-6 h-6" })}
              </a>
            ))}
          </div>
        </div>
      </div>
      <div className="flex-col tablet:flex-row flex gap-4 tablet:gap-12 justify-between mt-8 tablet:mt-16">
        {props.copyright ? (
          <div className="txt-body-mobile-12 tablet:txt-body-14 text-placeholder">{props.copyright}</div>
        ) : null}
        <div className="flex flex-wrap gap-3 tablet:gap-8 txt-body-mobile-12 tablet:txt-body-14 text-placeholder">
          {props.links.map((v, idx) => (
            <UniversalLinkWrapper className="cursor-pointer select-none" key={idx} spec={v.link}>
              {v.label}
            </UniversalLinkWrapper>
          ))}
        </div>
      </div>
    </div>
  );
};
